import React from 'react';
import { motion } from 'framer-motion';
import { skillGroups } from '../data/personalData';

export const Skills: React.FC = () => {
  return (
    <section id="skills" className="py-24 px-6 bg-background">
      <div className="max-w-5xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="mb-10"
        >
          <p className="font-mono text-sm text-accent mb-2">## schema</p>
          <h2 className="text-3xl sm:text-4xl font-bold text-text">skills</h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-5">
          {skillGroups.map((g, gi) => (
            <motion.div
              key={g.group}
              initial={{ opacity: 0, y: 14 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: (gi % 2) * 0.06 }}
              className="rounded-lg border border-border bg-surface/60 p-5 hover:border-accent/40 transition-colors"
            >
              <div className="font-mono text-xs mb-4 flex flex-wrap items-baseline gap-x-2">
                <span className="text-accent2">{g.group}</span>
                <span className="text-muted/70">-- {g.label}</span>
              </div>
              <div className="flex flex-wrap gap-2">
                {g.items.map((item) => (
                  <span
                    key={item}
                    className="px-3 py-1.5 text-sm text-text rounded border border-border bg-background/50 hover:border-accent hover:text-accent transition-colors cursor-default"
                  >
                    {item}
                  </span>
                ))}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
